"use client";

import { c as _c } from "react/compiler-runtime";
import { domMax, LazyMotion, MotionConfig } from "motion/react";
export function MotionProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <LazyMotion features={domMax}><MotionConfig reducedMotion="user">{children}</MotionConfig></LazyMotion>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}